// Single source of truth for StringsSG NAP (Name, Address, Phone) data.
// Keep this in sync with the Google Business Profile - inconsistent NAP
// across pages suppresses local search rankings.

import googleRatingData from '../data/google-rating.json'

export const businessName = "StringsSG Singapore"
export const legalName = "StringsSG Pte Ltd"
export const uen = "201813375G"

// Registered office / headquarters (ACRA), distinct from the Paya Lebar branch below.
// Postcode confirmed by StringsSG 2026-09-22 (was 188976, a Bugis code, in error).
export const hqAddress = {
    streetAddress: "33 Ubi Avenue 3, Vertex",
    addressLocality: "Singapore",
    addressRegion: "Singapore",
    postalCode: "408868",
    addressCountry: "SG",
}
export const hqGeo = { latitude: 1.3329596, longitude: 103.8941162 }
export const hqPhone = "+65 6680 3926"

// Branch office
export const branchAddress = {
    streetAddress: "Paya Lebar Square, 60 Paya Lebar Rd",
    addressLocality: "Singapore",
    addressRegion: "Singapore",
    postalCode: "409051",
    addressCountry: "SG",
}
export const branchGeo = { latitude: 1.3188149, longitude: 103.8925808 }

// WhatsApp-only customer service line (no inbound voice)
export const whatsAppNumber = "6593512695"
export const whatsAppDisplay = "+65 9351 2695"
export const whatsAppUrl = `https://wa.me/${whatsAppNumber}`

// Google Business Profile.
//
// The rating and review count are refreshed at build time by
// scripts/fetch-google-rating.mjs, which writes data/google-rating.json.
// That file is committed, so a build without GOOGLE_PLACES_API_KEY still ships
// a sane value rather than an empty one.
//
// These feed VISIBLE PAGE CONTENT ONLY. They must never be put back into
// JSON-LD aggregateRating: Google's review-snippet guidelines make a business
// ineligible for star ratings on reviews it controls about itself, and
// separately say "Don't aggregate reviews or ratings from other websites".
export const gbpUrl = "https://maps.app.goo.gl/j63oGWoaSbk9c4zj6"

const FALLBACK_RATING = "4.9"
const FALLBACK_REVIEW_COUNT = "136"

const isSaneRating = (value) => {
    const n = Number(value)
    return Number.isFinite(n) && n >= 1 && n <= 5
}

const isSaneCount = (value) => {
    const n = Number(value)
    return Number.isInteger(n) && n > 0
}

export const googleRating = isSaneRating(googleRatingData.rating)
    ? String(googleRatingData.rating)
    : FALLBACK_RATING

export const googleReviewCount = isSaneCount(googleRatingData.reviewCount)
    ? String(googleRatingData.reviewCount)
    : FALLBACK_REVIEW_COUNT

export const socialProfiles = [
    "https://www.facebook.com/StringsSG",
    "https://www.linkedin.com/company/stringssg/",
    "https://www.youtube.com/channel/UCOcyUdhVeOZf2kXTGtg9oHw/",
    whatsAppUrl,
    gbpUrl,
]
